import { render, staticRenderFns } from "./CatalogGeneratorList.vue?vue&type=template&id=d813761a&scoped=true&lang=pug"
import script from "./CatalogGeneratorList.vue?vue&type=script&lang=js"
export * from "./CatalogGeneratorList.vue?vue&type=script&lang=js"
import style0 from "./CatalogGeneratorList.vue?vue&type=style&index=0&id=d813761a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d813761a",
  null
  
)

export default component.exports